'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction3 from "./scala.scalajs.runtime.-Anon-Function3.js";
var $p;
/** @constructor */
function $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(f) {
  this.NG = null;
  this.NG = f;
}
export { $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96 as $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96 };
$p = $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96.prototype = new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction3.$h_sjsr_AnonFunction3();
$p.constructor = $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96;
/** @constructor */
function $h_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96() {
}
export { $h_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96 as $h_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96 };
$h_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96.prototype = $p;
$p.jj = (function(x0, x1, x2) {
  return (0, this.NG)(x0, x1, x2);
});
var $d_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96, "scala.scalajs.runtime.AnonFunction3.$$Lambda$73f37e31ba038fe839c174212837da323f140c96", ({
  w7: 1,
  w6: 1,
  g3: 1,
  ew: 1
}));
export { $d_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96 as $d_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96 };
